import { TVehicleCondition } from "shared/types/assetBuilder";

export const isVehicleCondition = (
  condition: any,
): condition is TVehicleCondition => {
  return !!condition && ["New", "Used", "CPO", "All"].includes(condition);
};
